import { render, staticRenderFns } from "./PortContainerPage.vue?vue&type=template&id=67caaea6&scoped=true"
import script from "./PortContainerPage.vue?vue&type=script&lang=js"
export * from "./PortContainerPage.vue?vue&type=script&lang=js"
import style0 from "./PortContainerPage.vue?vue&type=style&index=0&id=67caaea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67caaea6",
  null
  
)

export default component.exports